import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { InstructionsModalComponent } from './instructions-modal/instructions-modal.component';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { CommonService } from 'src/app/services/common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-instructions',
  templateUrl: './instructions.component.html',
  styleUrls: ['./instructions.component.scss']
})
export class InstructionsComponent implements OnInit {


  gridApi: GridApi;
  columnDefs;
  operations;
  rowData;
  tempoperation;
  advanceSearch;
  selectedRow;
  insForm: UntypedFormGroup;
  collapesedOrNot: boolean = false;
  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commomservice:CommonService
  ) {

  }
  // this.columnDefs = [ { "headerName": "FAQ", "field": "QUESTION" }, { "field": "MODULES", "headerName": "Program" }, { "field": "STATUS", "headerName": "STATUS" }];
  ngOnInit() {

    // this.insForm = new UntypedFormGroup({
    //   Progarm: new UntypedFormControl(""),
    //   Instruction: new UntypedFormControl(""),


    // });



    this.collapesedOrNot = false;
    // this.criteriaService.getInstructionsCriteria().subscribe(criteria => {
    //   this.columnDefs = criteria.columnDefs;
        this.columnDefs =
        [{ "field": "NAME", "headerName": "User Instruction Names" } ,
        {headerName : "Program" , "field" :"ModuleStr"  }];
      // this.advanceSearch = criteria.advanceSearch;

      //this.operations = [  { "name": "Edit", "id": "edit" }];

      this.tempoperation = [ ];
      if(this.commomservice.getScreenPermission("613","E")){
      this.tempoperation.push({
        "name": "Edit",
          "id": "edit"
      });
    }
      this.operations = this.tempoperation.map(operation => {
        //debugger
        return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
      });


      // var formData = this.insForm.value;
      //this.setSearchSummary();

      this.setSummary("-1");


  }

  setSummary(text)
   {
    this.summaryService.getRecords("api/instruction/fetchinstructions/"+ text).subscribe(summary => {
      this.rowData = summary;
    });
  }

  // setSearch() {
  //   this.SearchClear();

  //   this.setSummary("-1")
  // }

  // SearchClear() {
  //   this.insForm = new UntypedFormGroup({
  //     NAME: new UntypedFormControl("")
  //   });
  // }

  // AdvanceSearch() {
  //   var formData = this.insForm.value;
  //   this.setSummary(formData.NAME);
  // }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

 onRowDoubleClicked(event) {
  //debugger
   const modelRef=this['self'].modalService.open(InstructionsModalComponent, {
    backdrop: false,
    keyboard: false,
    windowClass:'modal-vlg right modal-right',
    animation: true
  });
  modelRef.componentInstance.Content={
    heading: 'View',
    content: { id: this.selectedRow['ID'] }
  }
  }

 edit() {


  const modalRef = this['self'].modalService.open(InstructionsModalComponent, {
    backdrop: false,
    keyboard: false,
    windowClass:'modal-llg right modal-right',
    animation: true,

  });
  modalRef.componentInstance.Content=  {
    heading: 'Edit User',
    content: { id: this['self'].selectedRow['ID'] }
  }
  modalRef.result.then(result => {
     this['self'].setSummary("-1");
   })
  }

  // delete() {
  //   this["self"].modalRef = this["self"].modalService.show(DeleteBoxComponent);
  // }

  // active() {
  //     this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {data:{heading:'Active',content: { heading: '', description: 'Selected Records has been made Active.'}}});
  // }

  // inactive() {
  //     this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {data:{heading:'Inactive',content: { heading: '', description: 'Selected Records has been made Inactive.'}}});
  // }


}
